/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NamirasoftAccountServer } from "./NamirasoftAccountServer";
import { NamirasoftAccountServerBase } from "./NamirasoftAccountServerBase";

export class NamirasoftAccountServerEmail extends NamirasoftAccountServerBase
{
    constructor(server: NamirasoftAccountServer)
    {
        super(server);
        this.Request = this.Request.bind(this);
        this.Verify = this.Verify.bind(this);
    }
    async Request(): Promise<{ next_time: number, error: (string | null) }>
    {
        let path = `/email/request`;
        let { data } = await this.server._post<{ next_time: number, error: (string | null) }>(path, {});
        return data;
    }
    async Verify(body: { code: string }): Promise<void>
    {
        let path = `/email/verify`;
        await this.server._post<void>(path, {}, body);
    }
};